import { Alert, AlertTitle, Box, Button, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useHistory } from 'react-router-dom';
import useAccountSetup, { listJoin } from '../../hooks/useAccountSetup';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: { marginBottom: theme.spacing(2) },
  })
);

/**
 * Team-level setup the account still needs, shown alongside the email and
 * mobile verification prompts so everything outstanding lives in one place.
 *
 * These settings belong to the team rather than the individual, and only an
 * owner can change them, so teammates are told who to ask instead of being
 * sent to a page the API would reject them from.
 */
const SetupIncomplete = () => {
  const classes = useStyles();
  const { missing, isTeammate } = useAccountSetup();
  const history = useHistory();

  if (missing.length === 0) return null;

  return (
    <>
      {missing.map((requirement) => {
        const mustAskOwner = requirement.ownerOnly && isTeammate;
        return (
          <Box key={requirement.key} className={classes.container}>
            <Alert severity="info">
              <AlertTitle>{requirement.title}</AlertTitle>
              {requirement.missingLabels.length > 0 ? (
                <>
                  Still needed: {listJoin(requirement.missingLabels)}.{' '}
                </>
              ) : null}
              {requirement.why}{' '}
              {mustAskOwner ? (
                `Please ask your account owner to set this up under ${requirement.settingsLabel}.`
              ) : (
                <Button onClick={() => history.push(requirement.settingsPath)}>{requirement.actionLabel}</Button>
              )}
            </Alert>
          </Box>
        );
      })}
    </>
  );
};

export default SetupIncomplete;
